const NAMESPACE = 'ui-search-map-filters';

const SEARCH_FIELD_NODE_ID = `${NAMESPACE}__location-search`;

export { NAMESPACE, SEARCH_FIELD_NODE_ID };
